import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Permission } from '../common/enums/permissions';
import { AuthGuard } from '../core/authentication/auth.guard';
import { PermissionGuard } from '../core/authentication/permission.guard';
import { WorkerFileVerificationComponent } from './worker-file-verification.component';

const routes: Routes = [
  {
    path: 'admin/workerfiles/:id',
    component: WorkerFileVerificationComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      permissions: [Permission.VerifyWorkerFiles],
    },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class WorkerFileVerificationRoutingModule {}
